import * as React from "react";
import { cn } from "../../lib/utils";

const alertVariants = {
    default: "bg-gray-50 border-gray-200 text-gray-800",
    info: "bg-cyan-50 border-cyan-200 text-cyan-900",
    success: "bg-green-50 border-green-200 text-green-900",
    warning: "bg-yellow-50 border-yellow-200 text-yellow-900",
    danger: "bg-red-50 border-red-200 text-red-900",
};

function Alert({ className, variant = "default", children, ...props }) {
    return (
        <div
            role="alert"
            className={cn(
                "relative w-full rounded-lg border px-4 py-3 text-sm",
                alertVariants[variant] || alertVariants.default,
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
}

function AlertDescription({ className, children, ...props }) {
    return (
        <div className={cn("text-sm [&_p]:leading-relaxed", className)} {...props}>
            {children}
        </div>
    );
}

export { Alert, AlertDescription };
